import { api } from '../../actions';
import { createReducer } from '../../helpers';

const initialState = {
    all: 0,
    unassigned: 0,
    my: 0,
};

export default createReducer(initialState, {
    [api.conversations.statistics.success]: (state, action) => action.result.conversations,
});
